export default "__VITE_ASSET__DRzfbnZM__"